const Form065EN = {
    stepName: {
        importantNotes: "重要事項",
        information: "基本資料",
        section1: "第I部",
        section2: "第II部",
        section3: "第III部",
        // toBeCompletedByTheSchool: "由學校完成",
        // confirm: "資料確認",
        confirmation: "確認",
    },
    label: {
        conditionsCheck: "本人已閱讀「個人資料收集聲明」及完全明白其內容。", // "本人已參閱及明白｢收集個人資料聲明｣。",
        iamStatement: "本人明白需透過「智方便+」帳戶以辧理申請。", //"本人明白此電子表格需要使用｢智方便+｣的數碼簽署功能。",
        information: {
            noteList: {
                note1: "請在填寫前，詳細閱讀個人資料收集聲明。",
                note2: "請確保教師知悉所填報的內容，並已閱讀個人資料收集聲明。",
                note3: "如就填寫本表格有任何查詢，請與有關學校發展主任聯絡。",
            },
            note: {
                note: "注意",
                // note1: "請在填寫前，詳細閱讀列載於附頁的個人資料收集聲明。",
                // note2: "請確保教師知悉所填報的內容，並已閱讀列載於附頁的個人資料收集聲明。",
                // note3: "如就填寫本表格有任何查詢，請與有關學校發展主任聯絡。",
            },
            ssdoOption: {
                Central_and_Western: "中西區",
                Southern: "南區",
                Wan_Chai: "灣仔區",
                Islands: "離島區",
                HKEast: "港島東區",
                Kowloon_City: "九龍城區",
                Sham_Shui_Po: "深水埗區",
                Sai_Kung: "西貢區",
                Kwun_Tong: "觀塘區",
                Wong_Tai_Sin: "黃大仙區",
                Yau_Tsim_Mong: "油尖旺區",
                Tai_Po: "大埔區",
                North: "北區",
                Sha_Tin: "沙田區",
                Kwai_Chung_and_Tsing_Yi: "葵青區",
                Tsuen_Wan: "荃灣區",
                Tuen_Mun: "屯門區",
                Yuen_Long: "元朗區",
            },
            title: "正本：",
            title1: "教育局公積金組",
            title2: "副本：",
            title3: "學校所屬的教育局區域教育服務處",
            title4: "﹝經辦人：高級學校發展主任 ",
            title5: "第二副本：",
            title6: "學校存檔",
            ssdo: "高級學校發展主任",
            schoolName: "學校名稱",
            contactAndTelText1: "學校聯絡人姓名",
            // contactAndTelText2: "及其電話號碼",
            contactAndTelText3: "(以便教育局處理本表格時作查詢之用)",
            contactPerson: "聯絡人",
            schoolCode: "學校代碼",
            schoolProgram: "授課時間",
            schoolTel: "學校電話號碼",
            nameOfTeacherInChinese: "教師中文姓名",
            nameOfTeacherInEnglish: "教師英文姓名",
            hkid: "香港身份證號碼",
            srn: "員工檔號",
        },
        completedByTheSchool: {
            section: {
                section1: "第 I 部 （由學校填寫）",
                section2:
                    "第 II 部（由學校填寫。請確保教師知悉所填報的內容。）",
            },
            title: {
                a: "A. 署任資料",
                b: "B. 扣減署任津貼資料",
                c: "C. 休假/缺勤性質",
                d: "D. 合資格署任期",
                e: "E. 退還署任津貼",
            },
            note: {
                note1: "教師在署任合資格職級期間連續休假超過 3 個工作天，將會喪失整段休假期間(包括休假日及當中的公眾假期和星期日)的署任津貼。",
                note2: "學校必須按照教育局通告第1/2006號及其附錄「教職員批假指引」、第16/2015號(侍產假適用)及第16/2018號(延長產假適用)的規定批核假期。",
                note3: "教師在署任合資格職級期間休假及/或缺勤超逾 3 天(因病假或參加經批准的訓練及擔任獲授權的職務而缺勤除外)，有關休假及/或缺勤日數不獲計算在合資格署任期內。",
                note4: "教師署任合資格職級達連續 30 個曆日或以上，可獲發放署任津貼。",
            },
            substantiveRank: "實任職級",
            rankOfActingAppointment: "署任職級",
            actingPeriod: "署任期",
            actingPeriodFrom: "由",
            actingPeriodTo: "至",
            absence: "休假/缺勤日期",
            absenceFrom: "由",
            absenceTo: "至",
            autoGenerate: "自動填寫",
            totalDays: "總天數",
            reasonCode: "休假/缺勤原因代碼",
            nameOfTeacher: "教師姓名",
            srn: "員工檔號",
            mySchool: "參照本表格的第 I 部，本校",
            note1: "現請教育局相應調整有關教師的署任津貼",
            note2: "教師的休假/缺勤 會/不會",
            note2a: " 計算在發放署任津貼的合資格署任期內",
            note3: "教師的休假/缺勤 會/不會",
            note3a: " 導致教師未能符合最低署任期限以支取署任津貼的基準",
            termsConditions: "本人已參閱、明白並同意上述條款和條件。",
        },

        reasonCodeOption: {
            1: "01 有薪病假",
            2: "02 無薪病假",
            3: "03 有薪產假/肺病特別假期",
            4: "04 無薪產假/肺病特別假期",
            5: "05 有薪侍產假 ",
            6: "06 有薪進修假期",
            7: "07 無薪進修假期",
            8: "08 出任陪審員或證人的有薪假期",
            9: "09 其他無薪假期",
            10: "10 其他有薪假期",
        },
        schoolProgramOption: {
            am: "上午",
            pm: "下午",
            wholeDay: "全日",
        },
        note2Option: {
            yes: "會",
            no: "不會",
        },
        mySchoolOption: {
            note1: "須在教師署任合資格職級期間連續休假超過 3 個工作天的情況下，退還",
            note2: "因教師的休假/缺勤導致該教師未能符合最低署任期限以支取署任津貼的基準，故須安排退還該教師整段署任期間的署任津貼。",
            note3: "已支付予",
            note4: "該教師整段休假期間(包括休假日及當中的公眾假期和星期日)的署任津貼。",
        },
        confirm: {
            signatureOfSchoolSupervisor: "校監簽署",
            nameOfSchoolSupervisor: "校監姓名",
            schoolChop: "校印",
            ssdo: "高級學校發展主任",
            ssdoOption: {
                section3: "主任",
                section2: "校長",
            },
            section: {
                section3: "第 III 部",
            },
            statement: "聲明",
            note: {
                note: "本人已根據有關的《資助則例》及教育局通告第 8/2004 號「署任安排和發放署任津貼」的規定，核對上文第 I 部及第 II 部的資料已完整填妥，並核實有關資料。本人確認本表格第 I 部及第 II 部的資料正確無誤。本人已通知上述教師有關休假/缺勤對計算署任期及發放署任津貼的影響。本人並承諾本校會把多付的薪金津貼退還教育局。",
                note1: "備註：",
                // note2: "連續休假超過 3 個工作日的，將被沒收代理任用教師的整個假期期間的代理津貼（包括假期和中間公共假期和星期日）。",
                // note3: "學校須遵照教育局通告第 1/2006 號及其附件《批假指引》、第 16/2015 號（適用於陪產假）及第 16/2018 號（適用於延長產假）。 准予休假。",
                // note4: "教師在代理期內因受聘為合資格職級而請假及/或缺勤超過 3 天（不包括病假及授權培訓及職務缺勤），不計入資格期。",
                // note5: "教師連續在合資格職級擔任代理職務連續 30 天或以上，可領取代理津貼。",
            },
        },
        statement: {
            title: {
                title1: "個人資料收集聲明",
                title2: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
            },
            note: {
                a: "辦理與聘用有關的事宜；",
                b: "處理發放薪金津貼及其他政府資助；",
                c: "計算公積金的供款；",
                d: "進行核數工作；",
                e: "進行研究及統計資料，以便規劃教育服務；",
                f: "處理有關教育專業人員發展的事宜；",
                g: "執行相關《資助則例》、《教育條例》、《教育規例》及《補助/津貼學校公積金規則》的規定。",
                note1: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
                note2: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
                note3: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
                note4: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。",
            },
        },
        note: {
            note1: "教師的休假/缺勤 ",
            note2: " 計算在發放署任津貼的合資格署任期內。",
            note3: " 導致教師未能符合最低署任期限以支取署任津貼的基準。",
        },
    },
    errorMsg: {
        schoolName: "學校名稱",
        contactPerson: "聯絡人",
        schoolCode: "請輸入一個有效的學校代碼",
        schoolTel: "請輸入一個有效的電話號碼",
        nameOfTeacherInChinese: "請輸入一個有效的教師中文姓名",
        nameOfTeacherInEnglish: "請輸入一個有效的教師英文姓名",
        hkid: "請輸入一個有效的香港身份證號碼",
        srn: "請輸入一個有效的員工檔號",
        substantiveRank: "實任職級",
        rankOfActingAppointment: "署任職級",
        E0001: "請輸入正確的規則",
        E0002: "請選擇署任期內的日期 ",
        E0003: "請在署任期內選擇休假/缺勤日期。",
        schoolTelMax: "電話號碼必須為最多12位數",
        schoolCodeMin: "請輸入4位數的学校代码",
        srnMin: "請輸入8位數的員工檔號",
        E0005: "第一項是必填項",
    },
};
export default Form065EN;
